import React, { useState } from "react";
import FeedbackForm from "./components/FeedbackForm";
import "./App.css";

function App() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="container">
      <header className="nhs-header">
        <img
          src="/headerLogo.png"
          alt="NHS Logo"
          className="nhs-logo"
        />
      </header>

      {!submitted ? (
        <FeedbackForm onSubmitted={() => setSubmitted(true)} />
      ) : (
        <h2 style={{ textAlign: "center" }}>Thanks for your feedback!</h2>
      )}
    </div>
  );
}

export default App;
